<template>
  <div class="result_wrapper">
    <!-- 支付结果页面 -->

    <!-- 成功/失败图标 -->
    <div class="result_icon">
      <img
        v-if="$condition.isOrderStatus_success(orderStatus)"
        src="../../assets/images/work/success.png"
        alt
      />
      <img v-else src="../../assets/images/work/failure.png" alt />
    </div>
    <div class="result_title">
      {{
        $condition.isOrderStatus_success(orderStatus) ? "付款成功" : "付款失败"
      }}
    </div>
    <div class="result_order">
      <div class="order_item item_first">
        <div class="order_tile">订单编号</div>
        <div class="order_content">
          <div ref="oid" class="oid"></div>
          <div class="oidCount" ref="oidCount"></div>
        </div>
      </div>
      <div class="order_item">
        <div class="order_tile">订单金额</div>
        <div class="order_content">{{ orderAmount }} 元</div>
      </div>
    </div>

    <!-- 操作按钮 -->
    <div class="result_btn">
      <div
        v-if="$condition.isOrderStatus_success(orderStatus)"
        class="success_btn btn_box"
      >
        <!-- <div class="again_btn btn">打印小票</div> -->
        <div @click="$utils.goBack()" class="offline_btn btn">关闭</div>
      </div>

      <div v-else class="failurn_btn btn_box">
        <div @click="payAgain()" class="again_btn btn ">再次支付</div>
        <!-- <div @click="offline(oid)" class="offline_btn btn">线下支付</div> -->
      </div>
    </div>

    <transition tag="div" name="pop">
      <qr-code
        v-show="showQRCode"
        @closeQRCode="closeQRCode"
        @failCallback="failCallback"
        @onPay="recovery"
        @successCallback="successCallback"
        :showQRCode="showQRCode"
        :orderParkingId="oid"
        :qrCodeInterFace="qrCodeInterFace"
        :isFirst="isFirst"
        :stationId="stationId"
      ></qr-code>
    </transition>
  </div>
</template>

<script>
import scanPayMixin from "../../utils/scanPayMixin";
import qrCode from "../../components/QRCode";
import JsBridge from "../../utils/JSBridge/JsBridge";
import { Dialog } from "vant";
import {
  ORDER_PARKING_OFFLINE_PAY,
  ORDER_PARKING_RECOVERY_QRCODE,
  ORDER_PARKING_QRCODE,
  ORDER_PARKING_RECOVERY_SCANCODE_PAY,
  ORDER_PARKING_SCANCODE_PAY
  // ORDER_STATUS_PENDING ,
} from "../../config/config";
export default {
  mixins: [scanPayMixin],

  data: () => ({
    //记录成功/失败
    orderStatus: 14,
    //订单id
    oid: "",

    //路由传参金额：预付金额 or 应付-实付金额
    orderAmount: "",

    showQRCode: false,

    isFirst: true,

    isRecovery: false,

    qrCodeInterFace: ""
  }),
  methods: {
    //补缴
    recovery(id) {
      this.onPay(id);
    },

    //线下支付，弹窗
    offline(orderParkingId) {
      Dialog.confirm({
        title: "系统提示",
        message: `<span style="font-size : 20px ;">请确认是否完成线下支付</span>`
      }).then(() => {
        if (orderParkingId) {
          this.$request(
            ORDER_PARKING_OFFLINE_PAY,
            {
              orderParkingId
            },
            res => {
              if (this.$condition.isRequestSuccess(res)) {
                this.$utils.goBack();
              }
            }
          );
        }
      });
    },

    payAgain() {
      if (this.isFirst) {
        Dialog.confirm({
          title: "系统提示",
          message: `<span style="font-size : 20px ;">是否确定再次支付</span>`
        }).then(() => {
          this.showQRCode = true;
        });
      } else {
        this.showQRCode = true;
      }
    },

    exceededPollingTimes() {
      this.$utils.goBack();
    },

    //二维码失败回调
    failCallback() {
      this.isFirst = true;

      this.$router.replace({
        name: "Result",
        params: {
          orderStatus: this.orderStatus,
          oid: this.oid,
          orderAmount: this.orderAmount,
          isRecovery: this.isRecovery
        }
      });
    },

    successCallback() {
      this.$utils.goBack();
      this.$utils.orderParkingId(this.orderParkingId);
    },

    closeQRCode() {
      this.isFirst = false;
      this.showQRCode = false;
    },

    changeOid(oid) {
      let oidArr = oid.split(",").filter(item => item);

      let oidStr = "";

      oidArr.forEach(item => {
        oidStr += `<div>${item}</div>`;
      });

      this.$refs.oidCount.innerHTML = `<div>共${oidArr.length}张订单</div>`;

      this.$refs.oid.innerHTML = oidStr;
    }
  },
  components: {
    qrCode
  },
  mounted() {
    this.$utils.showLoading();

    JsBridge.registerHandler("showQRCode", () => {
      this.showQRCode = true;
    });

    this.$utils.getStationId(stationId => {
      this.stationId = stationId;
    });

    this.orderStatus = this.$route.params.orderStatus;
    this.oid = this.$route.params.oid;

    this.orderAmount = this.$route.params.orderAmount;
    this.orderParkingId = this.oid;

    this.isRecovery = this.$route.params.isRecovery;

    // Toast(this.isRecovery + '')

    //以,切割id
    this.changeOid(this.oid);

    if (this.isRecovery) {
      this.qrCodeInterFace = ORDER_PARKING_RECOVERY_QRCODE;
      this.scanCodeInterface = ORDER_PARKING_RECOVERY_SCANCODE_PAY;
    } else {
      this.qrCodeInterFace = ORDER_PARKING_QRCODE;
      this.scanCodeInterface = ORDER_PARKING_SCANCODE_PAY;
    }

    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.timeout = setTimeout(() => {
      this.$utils.closeLoading();
    }, 1000);
  },
  beforeDestroy() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }
};
</script>

<style lang="less" scoped>
.pop-enter-to,
.pop-leave {
  transform: translateY(0);
  opacity: 1;
}
.pop-enter,
.pop-leave-to {
  transform: translateY(100%);
  opacity: 0;
}
.pop-enter-active,
.pop-leave-active {
  transition: all 0.3s;
}
.result_wrapper {
  width: 100vw;
  height: 100vh;
  background-color: #fff;
  position: absolute;
  top: 0;
  left: 0;
  padding: 20px 24px 0;
  z-index: 50;
  overflow: hidden;
}

.result_icon {
  width: 100px;
  height: 100px;
  margin: 0 auto;
  margin-top: 80px;

  > img {
    width: 100%;
    height: 100%;
  }
}

.result_title {
  font-size: 22px;
  width: 100%;
  text-align: center;
  margin-top: 20px;
}

.result_order {
  width: 100%;
  margin-top: 40px;
  font-size: 16px;

  .order_item {
    min-height: 30px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid rgba(7, 17, 27, 0.1);
    margin-top: 20px;
    font-size: 18px;

    &.item_first {
      align-items: stretch;
    }

    .order_content {
      font-size: 20px;
      color: #333;
      display: flex;
      flex-direction: column;

      .oid {
        max-height: 260px;
        overflow: scroll;
      }

      .oidCount {
        text-align: right;
      }
    }
  }
}

.result_btn {
  width: 100%;
  font-size: 16px;
  color: #fff;
  margin-top: 30px;

  .btn_box {
    width: 100%;
    display: flex;
    justify-content: space-around;
  }

  .btn {
    width: 40%;
    height: 48px;
    margin: 0 5%;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 20px;
  }

  .again_btn {
    width: 40%;
    background-color: #2860e5;
  }

  .offline_btn {
    width: 40%;
    background-color: #5fca4b;
    margin: 0 auto;
  }
}

.loading {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 51;
  width: 100%;
  height: 100%;
  background-color: rgba(7, 17, 27, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;

  .van-loading {
    color: #fff;
    font-size: 24px;
  }

  .van-loading__text {
    color: #fff;
  }
}
</style>
